import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { FavoritesProvider } from "@/context/FavoritesContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import { CookieBanner } from "@/components/CookieBanner";
import { FloatingContact } from "@/components/FloatingContact";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductPage from "@/pages/ProductPage";
import Checkout from "@/pages/Checkout";
import AuthPage from "@/pages/AuthPage";
import AccountPage from "@/pages/AccountPage";
import AdminPage from "@/pages/AdminPage";
import LegalPage from "@/pages/LegalPage";
import WithdrawalPage from "@/pages/WithdrawalPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <AuthProvider>
      <FavoritesProvider>
        <CartProvider>
          <BrowserRouter>
            <ScrollToTop />
            <div className="App min-h-screen bg-white font-sans text-ink antialiased">
              <Navbar />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/produse" element={<Shop />} />
                <Route path="/produs/:id" element={<ProductPage />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/autentificare" element={<AuthPage />} />
                <Route path="/cont" element={<AccountPage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/legal" element={<LegalPage />} />
                <Route path="/retragere" element={<WithdrawalPage />} />
                <Route path="*" element={<Home />} />
              </Routes>
              <Footer />
              <CartDrawer />
              <CookieBanner />
              <FloatingContact />
            </div>
            <Toaster position="top-center" richColors />
          </BrowserRouter>
        </CartProvider>
      </FavoritesProvider>
    </AuthProvider>
  );
}

export default App;
